import { Outlet } from "react-router-dom";

export const GenericPanel = () => <Outlet />;
